/* global G */
import { deleteKey, setKey } from 'lib/util'
import { apply, get } from 'app/_shared/events/attachment'
import { isRemote } from 'platform/adapter/attachment/helper'

/**
 * Attachment Apply Attribute Hook
 *
 * Resembles the hook version of the attachment `apply` event handler.
 *
 * Should come before any hooks like `reset` or `resetAttribute`, because it'll access
 * `model[G.STATE][G.REF]` (where `model` is the `attribute` sub-model), but after any
 * hooks like `submit` or `submitAttribute`, because these hooks most likely set the
 * G.REF using their `_updateModel` function.
 *
 * Will only execute `apply` if there are any attachments to apply. Will use the
 * attachment APIs `get` handler to determine that.
 *
 * @param {string} attribute the attribute of which to apply the attachments
 *
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const attachmentApplyAttribute = attribute => obj => async (...args) => {
  const model = obj[G.MODEL][G.CHILDREN][attribute]
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]

  const { [G.REF]: ref = null } = model[G.STATE] || {}

  const attachments = await get(obj, actionComponent, args)
  const localAttachments = attachments.filter(attachment => !isRemote(attachment))

  if (ref && !model[G.STATE][G.ERROR] && localAttachments?.length) {
    setKey(ref, G.REF, actionComponent[G.STATE])
    await apply(obj, actionComponent, args)
    deleteKey(G.REF, actionComponent[G.STATE])
  }

  return args
}

export default attachmentApplyAttribute
